import { 
    MessageResponseDto, 
    GetItemDto, 
    CreateItemDto, 
    EditItemDto,
    UtilItemControllerGet200Response,
    UtilityItemApiFp,
    DeleteItemDto,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseItemModel = UtilItemControllerGet200Response;
export type GetItemModel = GetItemDto;
export type MutateResponseItemModel = MessageResponseDto;
export type CreateItemModel = CreateItemDto;
export type UpdateItemModel = EditItemDto;
export type DeleteItemModel = DeleteItemDto;

export const apiItemFp =  UtilityItemApiFp(apiConfig);
export const getItemController = apiItemFp.utilItemControllerGet;
export const createItemController = apiItemFp.utilItemControllerCreate;
export const updateItemController = apiItemFp.utilItemControllerEdit;
export const deleteItemController = apiItemFp.utilItemControllerDelete;

export const QueryKeyItem = QueryKey.Item;